// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".back {\n  z-index: 10;\n}\n.inputBorderRadius > .MuiOutlinedInput-root {\n  border-radius: 15px !important;\n}\n", "",{"version":3,"sources":["webpack://src/components/clients/SetupClient/Form.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".back {\n  z-index: 10;\n}\n.inputBorderRadius > .MuiOutlinedInput-root {\n  border-radius: 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
